type MainViewArgs = {
  el: JQuery;
};

type ReportsInitializerHandle = {
  render: () => void;
  destroy: () => void;
};

export class ReportsMainView {
  private $el: JQuery;
  private currentFormView: ReportsInitializerHandle;
  private lightweightDialogOpen = false;
  private disposed = false;
  private readonly onPageHide: (event: PageTransitionEvent) => void;

  constructor({ el }: MainViewArgs) {
    this.$el = el;
    this.onPageHide = (event: PageTransitionEvent) => {
      if (!event.persisted) {
        this.destroy();
      }
    };
    window.addEventListener('pagehide', this.onPageHide);
    this.currentFormView = App.ES6.Initializers.Reports({
      tabElement: this.$el.find('#reports-view')[0],
      containerElement: this.$el[0],
    });
  }

  public lightweightAuthAction() {
    this.openLightweightModeDialog();
  }

  public render() {
    this.currentFormView.render();
  }

  public destroy() {
    if (this.disposed) {
      return;
    }
    this.disposed = true;
    window.removeEventListener('pagehide', this.onPageHide);
    this.currentFormView.destroy();
  }

  private openLightweightModeDialog() {
    if (this.lightweightDialogOpen) {
      return;
    }

    const dialog = new App.Views.LightweightMode();
    dialog.render();
    dialog.open();
    this.lightweightDialogOpen = true;

    dialog.$el.one('dialogclose', () => {
      this.lightweightDialogOpen = false;
    });
  }
}
